module.exports = __webpack_public_path__ + "img/split-01.ffe29eb0.jpg";